import { BaseListView } from "@/base/BaseListView";
import { definePendingListView } from "@/base/list/defineListView";

// Declinations (BRK-S251): a BaseListView page PMS can't serve yet. A market's
// decline, with its reasons, shows in the submission's quote comparison today.
// BRK-S210 wires this list to `GET /api/broker/declinations` once PMS-S561
// ships it; the columns are its.
const DECLINATIONS_LIST = definePendingListView({
  plannedEndpoint: "/api/broker/declinations",
  noun: "declinations",
  title: "Declinations",
  context: "Markets that declined to quote your submissions.",
  columns: ["Insured", "Coverage", "Carrier", "Declined on", "Reasons"],
  notYetAvailable: {
    title: "Declinations show on each submission",
    body: "A market that declines appears, with its reasons, in the submission's quote comparison.",
    href: "/submissions",
    linkLabel: "Go to Submissions",
  },
});

export function DeclinationsPage() {
  return <BaseListView def={DECLINATIONS_LIST} />;
}
